module.exports = __webpack_public_path__ + "static/media/intersection_group.43c45137.svg";